import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from "@angular/core";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {IIframePayload} from "@ispm/widgets/components/iframe-container-widget/interfaces/iframe-container.interface";
import {PlaceholderChildComponent} from "@ispm/layout/classes/placeholder-child-component.abstract";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'ispm-iframe-container-widget',
  templateUrl: './iframe-container-widget.component.html',
  styleUrls: ['./iframe-container-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('iframe-container')
export class IFrameContainerWidgetComponent extends PlaceholderChildComponent implements IWidgetItem {
  public widgetPayload: IIframePayload;

  constructor(
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
  ) {
    super();
  }

  set widgetData(widgetData: IIframePayload) {
    this.widgetPayload = widgetData;
    this.cd.markForCheck();
  }

  beforeClose() { }

  cleanURL(oldURL: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }
}
